// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"ed6e4a59","100":"b9bc6bbb","172":"145233fd","250":"7ed9ece9","349":"e24f54c1","729":"8a8112ba","736":"9f85040c","763":"5bba2a65","983":"2457f9c1"}[chunkId] + ".chunk.js";
};